<script>

    export let message = "Something went wrong. Please contact your system admin."

</script>

<div class="error-container">
    <p>{message}</p>
</div>
